import { RouteConfig } from 'vue-router';

import PageProducts from './PageProducts.vue';

export default {
  path: 'list',
  name: 'products',
  component: PageProducts,
  meta: {
    title: 'Produtos',
  },
} as RouteConfig;
